'use strict'

import { apiInstance, legacyV2 } from './index'
import { mapArgs } from 'utils/functions'

const accounts = {
  getAccounts (companyId, ...args) {
    console.log('This function is deprecated.')
    const params = mapArgs(...args)
    return apiInstance
      .get(`${legacyV2()}/company/${companyId}/accounts`, {
        params
      })
  }
}

export default accounts
